import React from 'react';
import { take } from 'lodash';
import { Box } from '@fiverr-private/theme';
import { Tooltip } from '@fiverr-private/tooltip';
import { getContext } from '@fiverr-private/fiverr_context';
import { Typography } from '@fiverr-private/typography';
import { Container } from '@fiverr-private/layout_components';
import { getAvatarGroupAvatarStyles } from '../styles';
import { AVATARS_MAX_LENGTH, MAX_TOOLTIP_ITEMS, OVERLAY_DISTANCE } from '../constants';
import type { LeftAvatarsProps } from './types';

const LeftAvatars = ({ tooltipPosition, copies, hasAnimatedChildren, leftAvatars, size }: LeftAvatarsProps) => {
  const leftAvatarsToShow = take(leftAvatars, MAX_TOOLTIP_ITEMS);
  const { locale } = getContext();
  const isMultiDigit = leftAvatars.length - leftAvatarsToShow.length > 10;

  return (
    <Container
      style={{
        marginLeft: -OVERLAY_DISTANCE,
      }}
    >
      <Tooltip
        size="sm"
        as="div"
        position={tooltipPosition}
        content={
          <Box as="ul" listStyleType="none" padding="0">
            {React.Children.map(leftAvatarsToShow, (child) => {
              const { displayName, username } = (child as React.ReactElement).props;
              return <li>{displayName || username}</li>;
            })}
            {leftAvatarsToShow.length < leftAvatars.length && (
              <Container as="li">
                {copies?.moreItemsText(
                  Intl.NumberFormat([locale, 'en-US'], {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  }).format(leftAvatars.length - leftAvatarsToShow.length)
                )}
              </Container>
            )}
          </Box>
        }
      >
        <Box
          {...getAvatarGroupAvatarStyles({
            hasAnimatedChildren,
            type: 'leftAvatars',
            leftAvatars,
            size,
            isMultiDigit,
          })}
        >
          <Typography as="span">+</Typography>
          <Typography as="span">
            {leftAvatars.length > AVATARS_MAX_LENGTH ? AVATARS_MAX_LENGTH : leftAvatars.length}
          </Typography>
        </Box>
      </Tooltip>
    </Container>
  );
};

LeftAvatars.displayName = 'LeftAvatars';
export default LeftAvatars;
